<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="sku-detail">
    <!-- <vx-card v-if="!isLoading && sku && !sku.competition">
      <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
        <p>Oops !!! There is an issue showing the details of this SKU. Kindly contact the system admin.</p>
      </vs-alert>
    </vx-card>-->

    <div
      v-if="!isLoading && sku && !sku.competition"
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img src="@/assets/images/pages/500.png" alt="graphic-500" class="mx-auto mb-4" />
      <h1
        class="sm:mx-0 mx-4 mb-4 sm:mb-12 text-5xl d-theme-heading-color"
      >SKU detail is out-of-date!</h1>
      <h5 class="sm:mx-0 mx-4 mb-4 sm:mb-12 text-1xl">Kindly contact the system admin.</h5>
    </div>
    
    <div class="vx-row" v-if="!isLoading && sku && sku.competition">
      <div class="vx-col w-full lg:w-1/4">
        <vx-card title="About" class="mt-base">
          <div>
            <vs-avatar
              class="user-profile-img"
              :src="sku.image ? sku.image : require(`@/assets/images/pages/no-image.png`)"
              size="150px"
            />
          </div>
          <template slot="actions">
            <feather-icon icon="MoreHorizontalIcon"></feather-icon>
          </template>

          <div class="user-bio">
            <p>{{sku.name}}</p>
          </div>

          <div class="mt-5 flex">
            <vs-chip
              :color="getStockStatusColor(sku)"
              v-if="sku.client_price && sku.client_price !== 0"
            >
              {{sku.client_price > 0 ? 'In Stock' : 'Out of Stock'}}
            </vs-chip>
            <vs-chip transparent color="primary" v-if="sku.price_index">
              <vs-avatar text="PI"/>
              {{sku.price_index | numFormat('0.00')}}
            </vs-chip>
          </div>

          <div class="mt-5">
            <h6>Price: </h6>
            <p>{{sku.client_price && sku.client_price !== 0 ? "" : "Not Available"}}</p>
          </div>
          <div class="mt-1 flex">
            <vs-chip v-if="sku.client_price && sku.client_price !== 0">
              <vs-avatar color="dark" text="OP"/>
              {{sku.client_price | numFormat('$ 0,0.00')}}
            </vs-chip>
            <vs-chip v-if="sku.store_price && sku.store_price !== 0">
              <vs-avatar text="SP"/>
              {{sku.store_price | numFormat('$ 0,0.00')}}
            </vs-chip>
          </div>


          <div class="mt-5">
            <h6>ID:</h6>
            <p>{{sku.code}}</p>
          </div>

          <div class="mt-5">
            <h6>Category:</h6>
            <p>{{sku.category}}</p>
          </div>

          <div class="mt-5">
            <h6>Brand:</h6>
            <p>{{sku.brand}}</p>
          </div>

          <div class="mt-5">
            <h6>MPN:</h6>
            <p>Not Available</p>
          </div>

          <div class="mt-5">
            <h6>EAN:</h6>
            <p>Not Available</p>
          </div>

          <!-- <div class="mt-5 flex">
            <h6>Price:</h6>
            <h3>{{sku.client_price | numFormat('$ 0,0')}}</h3>
          </div> -->

          <!-- <div class="social-links flex mt-4">
            <feather-icon
              svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
              class="mr-2"
              icon="FacebookIcon"
            ></feather-icon>
            <feather-icon
              svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
              class="mr-2"
              icon="TwitterIcon"
            ></feather-icon>
            <feather-icon
              svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
              class="mr-2"
              icon="InstagramIcon"
            ></feather-icon>
          </div>-->
        </vx-card>
      </div>

      <!-- LINE CHART -->
      <div class="vx-col w-full lg:w-3/4" v-if="!showCompare">
        <div class="vx-row mt-base">
          <vx-card title="Trend of Prices and Out-of-stock status">
            <template slot="actions">
              <!-- <change-time-duration-dropdown /> -->
              <change-time-duration-dropdown class="text-grey self-end mr-5" />
              <feather-icon icon="GridIcon" class="mr-4" svgClasses="w-6 h-6" @click="showCompare = !showCompare"></feather-icon>
              <feather-icon icon="XCircleIcon" svgClasses="w-6 h-6" @click="hideSkuContainer"></feather-icon>
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <div class="flex">
                <div class="mr-6" v-if="sku.client_price !== 0">
                  <p class="mb-1 font-semibold">Our Price</p>
                  <p
                    class="text-xl"
                    :class="sku.competition.bestPrice !== 0 && sku.competition.pos === 'down' ? 'text-danger' : 'text-success'"
                  >{{sku.client_price | numFormat('$ 0,0[.]00')}}</p>
                </div>
                <div class="mr-6">
                  <p class="mb-1 font-semibold">Best of Retailers</p>
                  <p class="text-2xl">
                    {{sku.competition.bestPrice | numFormat('$ 0,0[.]00')}}
                    <feather-icon
                      v-if="sku.client_price !== 0"
                      :icon="sku.competition.pos === 'down' ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[sku.competition.pos === 'down' ? 'text-danger' : 'text-success'  ,'stroke-current h-5 w-5 mb-1 mr-1']"
                    ></feather-icon>
                  </p>
                </div>
                <!-- <div>
                  <change-time-duration-dropdown class="self-end ml-5" />
                </div> -->
              </div>
            </div>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                class="competeTrend"
                ref="competeTrend"
                type="line"
                height="300"
                :options="competeGraphUpdated.chartOptions"
                :series="competeGraphUpdated.series"
              />
            </div>
          </vx-card>
        </div>
 
        <div class="vx-row mt-base">

          <manage-sku :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

          <vx-card title="Online Retailers">
            <div slot="no-body" class="mt-4">
              <div class="vx-row ml-2 mr-2" v-if="sku.competition.delta">
                <div class="vx-col w-full md:w-1/4 xl:w-1/4">
                <vx-card>
                  <div class="flex items-center justify-center">
                    <vue-apex-charts
                      type="bar"
                      height="70"
                      width="100"
                      :options="sparkLine"
                      :series="seriesSpark(sku.competition)"
                    />
                  </div>
                  <div class="mt-5 mb-1 text-center">
                    Retailers
                  </div>
                </vx-card>
                </div>
                <div class="vx-col w-full md:w-1/4 xl:w-1/4">
                    <statistics-card-line
                      hideChart
                      icon="GitCommitIcon"
                      :statistic="sku.competition.delta.amp | numFormat('$ 0,0[.]00')"
                      :statisticTitle="sku.competition.delta.ampLabel ? sku.competition.delta.ampLabel : 'Avg. Mkt. Price (AMP)'" 
                      color="success" />
                </div>

                <div class="vx-col w-full md:w-1/4 xl:w-1/4">
                    <statistics-card-line
                      hideChart
                      icon="GitPullRequestIcon"
                      :statistic="(sku.competition.delta.pdiff > 1 ? (sku.competition.delta.pdiff/100) : 0) | numFormat('0.0 %')"
                      :statisticTitle="sku.competition.delta.pdiffLabel ? sku.competition.delta.pdiffLabel : 'w.r.t Next High'" 
                      color="danger"/>
                </div>

                <div class="vx-col w-full md:w-1/4 xl:w-1/4">
                    <statistics-card-line
                      hideChart
                      icon="GitPullRequestIcon"
                      :statistic="(sku.competition.delta.ampdiff > 1 ? (sku.competition.delta.ampdiff/100) : 0) | numFormat('0.0 %')"
                      :statisticTitle="sku.competition.delta.ampdiffLabel ? sku.competition.delta.ampdiffLabel : 'w.r.t AMP'"
                      color="warning" />
                </div>
                
                
              </div>

              <vs-table search :data="competeGridUpdated">
                <template slot="thead">
                  <vs-th sort-key="name">Name</vs-th>
                  <vs-th sort-key="description_product">Product</vs-th>
                  <!-- <vs-th sort-key="popularity">Stock</vs-th> -->
                  <vs-th sort-key="price">Price</vs-th>
                  <!-- <vs-th sort-key="order_status">Compete Index</vs-th> -->
                  <vs-th sort-key="last_updated">Last Updated</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr
                    :class="{'font-bold': ( Number(sku.competition.bestPrice) !== 0 && (Number(tr.price) ===  Number(sku.competition.bestPrice)))}"
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>
                      <p class="product-name">{{ tr.name }}</p>
                    </vs-td>

                    <vs-td>
                      <div class="product-category">
                        <a :href="tr.link" target="_blank" rel="nofollow" class="flex text-black">
                          <feather-icon
                            icon="ExternalLinkIcon"
                            svgClasses="stroke-current text-grey w-4 h-4"
                            class="ml-2 mr-2"
                          />
                          {{ (tr.description_product !== '-' ? tr.description_product : sku.name) | ellipsis(40)}}
                        </a>
                      </div>
                    </vs-td>

                    <!-- <vs-td> -->
                      <!-- <div
                          class="h-3 w-3 rounded-full mr-2"
                          :class="'bg-' + getStockStatusColor(tr)"
                        ></div> -->
                      <!-- <vs-chip
                        :color="getStockStatusColor(tr)"
                      >{{getStockStatus(tr)}}</vs-chip> -->
                      <!-- <vs-avatar :color="getStockStatusColor(tr)" :text="getStockStatus(tr)"/> -->
                    <!-- </vs-td> -->

                    <vs-td>
                      <p class="product-price">
                        {{ Number(tr.price) | numFormat('$ 0,0[.]00')}}
                        <feather-icon
                          :icon="tr.pos === 'down' ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                          :svgClasses="[tr.pos === 'down' ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                        ></feather-icon>
                      </p>
                    </vs-td>

                    <!-- <vs-td>
                      <vs-progress
                        :percent="tr.price > 0 ? Number(tr.pos === 'down' ? 90 : 50) : 1"
                        :color="getCompeteIndexColor(tr)"
                        class="shadow-md"
                      />
                    </vs-td>-->

                    <vs-td>
                      <div class="product-price flex justify-start">
                        <small>{{tr.last_updated | dateParse('YYYY-MM-DDTHH:mm:ss') | dateFormat('D MMM, HH:mm')}}</small>
                      </div>
                      <div class="product-price flex justify-start">
                        <small :class="'text-'+getStockStatusColor(tr)">{{getStockStatus(tr)}}</small>
                      </div>
                      <!-- <vs-chip
                        :color="getStockStatusColor(tr)"
                      >{{getStockStatus(tr)}}</vs-chip> -->
                    </vs-td>
                    <vs-td>
                      <div class="vx-col w-full flex sm:w-auto ml-auto mt-2 sm:mt-0 justify-end">
                        <vs-button
                          radius
                          :color="tr.verified ? 'success' : 'danger'"
                          type="border"
                          icon-pack="feather"
                          :icon="tr.verified ? 'icon-thumbs-up' : 'icon-thumbs-down'"
                          size="small"
                          @click="(tr.verified = !tr.verified), viewDetails()"
                        ></vs-button>
                        <vs-button
                          radius
                          type="border"
                          icon-pack="feather"
                          icon="icon-edit"
                          size="small"
                          class="ml-3"
                          @click="editData(tr)"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
          <!-- <vx-card title="Time machine" class="carousel-example mt-base">
            <div>
              <swiper :options="swiperOption">
                <swiper-slide>
                  <img :data-src="require('@/assets/images/slider/01.jpg')" class="swiper-lazy" />
                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </swiper-slide>
                <swiper-slide>
                  <img :data-src="require('@/assets/images/slider/02.jpg')" class="swiper-lazy" />
                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </swiper-slide>
                <swiper-slide>
                  <img :data-src="require('@/assets/images/slider/03.jpg')" class="swiper-lazy" />
                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </swiper-slide>
                <swiper-slide>
                  <img :data-src="require('@/assets/images/slider/04.jpg')" class="swiper-lazy" />
                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </swiper-slide>
                <swiper-slide>
                  <img :data-src="require('@/assets/images/slider/05.jpg')" class="swiper-lazy" />
                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
              </swiper>
            </div>
          </vx-card>-->
        </div>
      </div>

      <!-- Related Products -->
      <div class="vx-col w-full lg:w-3/4" v-if="showCompare">
        <div class="vx-row text-center mt-base">
          <vx-card title="Related Products">
            <template slot="actions">
              <!-- <change-time-duration-dropdown /> -->
              <feather-icon icon="ActivityIcon" class="mr-4" svgClasses="w-6 h-6" @click="showCompare = !showCompare"></feather-icon>
              <feather-icon icon="XCircleIcon" svgClasses="w-6 h-6" @click="hideSkuContainer"></feather-icon>
            </template>
            <!-- <div class="related-headings text-left">
              <h3>Related Products</h3>
            </div> -->
            <vs-alert color="danger" icon="new_releases" active="true" class="mt-5" v-if="!sku.similar">
              <p>Similar Products are not tagged yet.</p>
            </vs-alert>
            <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" class="related-product-swiper px-12" v-if="sku.similar">
              <swiper-slide v-for="item in sku.similar" :key="item.sku_id" class="p-6 rounded cursor-pointer">

                <!-- Item Heading -->
                <div class="item-heading mb-4">
                  <p class="text-lg font-semibold truncate">{{ item.name }}</p>
                  <p class="text-sm">
                    <span class="mr-2">by</span>
                    <span>{{ item.brand }}</span>
                  </p>
                </div>

                <!-- Item Image -->
                <!-- <div class="img-container w-32 mx-auto my-base">
                  <img class="responsive" :src="item.image" :alt="item.name">
                </div> -->
                <div class="img-container h-32 flex items-center justify-center mb-4">
                  <img
                    :src="item.image ? item.image : require(`@/assets/images/pages/no-image.png`)"
                    :alt="item.name"
                    class="grid-view-img px-4"
                  />
                </div>

                <!-- Item Meta -->
                <div class="item-meta">
                  <!-- <star-rating :show-rating="false" :rating="item.rating" :star-size="14" class="justify-center" read-only /> -->
                  <span class="text-sm">Best of Channels</span>
                  <p class="text-lg font-medium text-primary">{{ item.competition.bestPrice | numFormat('$ 0,0.00')}}</p>
                  <!-- <vs-button
                    type="flat"
                    icon-pack="feather"
                    :icon="isSelected(item) ? 'icon-check-square' : 'icon-square'"
                    size="small"
                    @click="compare(item.code)"
                  ></vs-button> -->
                  <feather-icon
                    :icon="isSelected(item) ? 'CheckSquareIcon' : 'SquareIcon'"
                    svgClasses="ml-3 w-6 h-6"
                    @click="compare(item.code)"
                  ></feather-icon>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </vx-card>
        </div>
        <div class="vx-row">
          <vx-card title="Products Vs Retailers" class="mt-base">
            <div slot="no-body" class="mt-4">
              <vs-table pagination max-items="5" search :data="compareUnits">
                <template slot="thead">
                  <vs-th sort-key="name">Product</vs-th>
                  <vs-th sort-key="name">Best Price</vs-th>
                  <vs-th :data="th"
                    :key="indexth"
                    v-for="(th, indexth) in channels.keys()">{{th}}</vs-th>
                  <vs-th sort-key="name">Trend</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>
                      {{ tr.name }}
                      <p class="text-sm">
                        <span class="mr-2">by</span>
                        <span class="font-semibold">{{ tr.brand }}</span>
                      </p>
                    </vs-td>
                    <vs-td
                    class="font-bold"
                    >
                      {{tr.bestPrice | numFormat('$ 0,0.00')}}
                    </vs-td>
                    <vs-td :data="td"
                    :key="indextd"
                    v-for="(td, indextd) in tr.channels.values()">
                      <span v-if="!td.name">
                        <feather-icon
                          icon="XIcon"
                          svgClasses="ml-3 w-6 h-6 text-danger"
                        ></feather-icon>
                      </span>
                      <span v-else>
                        {{td.price | numFormat('$ 0,0.00')}}
                      </span>
                    </vs-td>
                    <vs-button
                      radius
                      type="border"
                      icon-pack="feather"
                      icon="icon-activity"
                      size="small"
                      class="ml-3 mt-3"
                      @click="showTrend(tr)"
                    ></vs-button>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
    </div>

    <!-- <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex justify-center mt-base">
                    <vs-button id="button-load-more-posts" class="vs-con-loading__container" @click="loadContent">Load More</vs-button>
                </div>
            </div>
    </div>-->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from '@/app/shared/components/ChangeTimeDurationDropdown.vue'

import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import StarRating from 'vue-star-rating'
import ManageSku from './ManageSku.vue'

import appConfig from "@/../appConfig.js";
import { appCommons } from '@/app/shared/services';
import { fetchArtefactUnit } from "../shared/services";

const chartColors = appConfig.chart.colors;

export default {
  data() {
    return {
      isNavOpen: false,
      wasSidebarOpen: null,
      showCompare: false,
      channels: [],
      compareUnits: [],
      selectedUnitsToCompare: [],
      callInProgress: false,
      // swiperOption: {
      //   // Enable lazy loading
      //   lazy: true,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
      // },
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 55,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 55
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 55
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      sku: {},
      isLoading: true,
      payload: {
        tags: [],
        dateRange: {
          startDate: "05/03/2019",
          endDate: "08/03/2019"
        },
        page: {
          size: 20,
          pos: 1
        },
        query: this.$route.params.id,
        mode: "quantity",
        type: "SKU",
        res: {}
      },
      competeGraph :{
        series: [],
        chartOptions: {
          annotations: {

          },
          chart: {
            type: "line",
            // height: 300,
            foreColor: "#999",
            stacked: false,
            dropShadow: {
              enabled: true,
              enabledSeries: [0],
              top: -2,
              left: 2,
              blur: 5,
              opacity: 0.06
            }
          },
          colors: chartColors,//['#00E396', '#0090FF'],
          stroke: {
            curve: "smooth",
            width: 3
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0,
            strokeColor: "#fff",
            strokeWidth: 3,
            strokeOpacity: 1,
            fillOpacity: 1,
            hover: {
              size: 6
            }
          },
          xaxis: {
            // type: "datetime",
            tickAmount: 10,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val ? appCommons.formatDate(val, 'DD/MM/YYYY', 'DD MMM') : val
              }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },
          yaxis: {
            // labels: {
            //   offsetX: 14,
            //   offsetY: -5
            // },
            // tooltip: {
            //   enabled: true
            // }
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              // formatter: function(val) {
              //   return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
              // }
            }
          },
          grid: {
            show: false
          },
          // tooltip: {
          //   x: {
          //     format: "dd MMM yyyy"
          //   },
          // },
          legend: {
            position: 'right',
            // horizontalAlign: 'left'
          },
          fill: {
            type: "solid",
            fillOpacity: 0.7
          }
        }
      },
      // competeGraph: {
      //   series: [],
      //   chartOptions: {
      //     chart: {
      //       stacked: false,
      //       toolbar: { show: false }
      //     },
      //     dataLabels: {
      //       enabled: false,
      //     },          
      //     stroke: {
      //       curve: "smooth",
      //       dashArray: [8],
      //       width: [2, 2]
      //     },
      //     grid: {
      //       show: false
      //     },
      //     legend: {
      //       show: false
      //     },
      //     colors: chartColors,
      //     fill: {
      //       type: "gradient",
      //       gradient: {
      //         shade: "dark",
      //         inverseColors: false,
      //         gradientToColors: chartColors,
      //         shadeIntensity: 1,
      //         type: "horizontal",
      //         opacityFrom: 1,
      //         opacityTo: 1,
      //         stops: [0, 100]
      //       }
      //     },
      //     markers: {
      //       size: 0,
      //       hover: {
      //         size: 5
      //       }
      //     },
      //     xaxis: {
      //       tickAmount: 10,
      //       labels: {
      //         style: {
      //           cssClass: "text-grey fill-current"
      //         },
      //         formatter: function(val) {
      //           return val ? appCommons.formatDate(val, 'DD/MM/YYYY', 'DD MMM') : val
      //         }
      //       },
      //       axisTicks: {
      //         show: false
      //       },
      //       categories: [],
      //       axisBorder: {
      //         show: false
      //       }
      //     },
      //     yaxis: {
      //       tickAmount: 5,
      //       labels: {
      //         style: {
      //           cssClass: "text-grey fill-current"
      //         },
      //         // formatter: function(val) {
      //         //   return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
      //         // }
      //       }
      //     },
      //     tooltip: {
      //         shared: false,
      //         intersect: false,
      //         y: {
      //           formatter: function (y) {
      //             if(typeof y !== "undefined") {
      //               return  y.toFixed(3);
      //             }
      //             return y;
      //           }
      //         }
      //       },
      //     // tooltip: {
      //     //   x: { show: false }
      //     // }
      //   }
      // },

      // Data Sidebar
      sparkLine: {
        chart: {
          height: 35,
          width: 100,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            columnWidth: "80%"
          }
        },
        colors: chartColors,
        stroke: {
          curve: "straight"
          // width: [1]
        },
        fill: {
          opacity: 0.3
        },
        xaxis: {
          crosshairs: {
            width: 1
          }
        },
        tooltip: {
          fixed: {
            enabled: false
          },
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function(seriesName) {
                return "";
              }
            }
          },
          marker: {
            show: false
          },
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="p-3" style="white-space: pre-wrap !important; max-width: 150px;">' +
              "<div><small>" +
              w.config.series[seriesIndex].name[dataPointIndex] +
              "</small></div>" +
              "<div><small>" +
              w.config.series[seriesIndex].data[dataPointIndex] +
              "</small></div>" +
              "</div>"
            );
          }
        }
      },
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: { 
    competeGraphUpdated() {
      return this.competeGraph;
    },
    competeGridUpdated() {
      let tempSource = []
      tempSource = Object.assign(tempSource, this.sku.competition.source);
      
      tempSource.sort(function(a, b) {
        return a.price - b.price;
      });
      return tempSource
    } 
  },
  methods: {
    getSkuInfo(code) {
      if(code !== this.payload.query) {
        this.payload.query = code ? code : this.$route.params.id;
        this.isLoading = true;
        this.$vs.loading({
          // background: this.backgroundLoading,
          // color: this.colorLoading,
          // container: "#exploreButton",
          // scale: 0.45,
          type: "radius"
        });
        fetchArtefactUnit(this.payload)
          .then(res => {
            this.sku = res.data.sku[0];

            this.sku.stock = {
              lastOrderDate: "Apr 27 2019",
              qty: 100,
              oos: "30 Apr 2019"
            };
            
            if(this.sku && this.sku.competition && this.sku.competition.delta && !this.sku.competition.delta.amp) {
              this.sku.competition.delta = {
                "amp": 0.0,
                "ampLabel": "Average Market Price ( AMP )",
                "pdiff": 0.0,
                "pdiffLabel": "Priced High w.r.t Next High",
                "ampdiff": 0.0,
                "ampdiffLabel": "Priced High w.r.t AMP"
              }
            }

            this.isLoading = false;
            this.buildTrendSeries();
            this.compare();
            this.$vs.loading.close();
          })
          .catch(error => {
            this.sku = {};
            this.isLoading = false;
            this.$vs.loading.close();
            throw new Error(error);
          });
      }
    },
    buildTrendSeries() {
      let series = [];
      let oosMap = new Map();

      let myBizData = {
        name: "",
        data: []
      };

      myBizData.name = "Our Price";
      let tempMyBizData = this.sku.competition.trend.client_data.map(d =>
        d
      );

      myBizData.data = tempMyBizData.reverse();

      if(this.sku.client_price !== 0) {
        // series.push(myBizData);
      }

      for (let i = 0; i < this.sku.competition.trend.data.length; i++) {
        let key = Object.keys(this.sku.competition.trend.data[i]);
        let data = {
          name: "",
          data: []
        };

        data.name = key[0];
        let prevData = 0;
        let tempData = this.sku.competition.trend.data[i][key[0]].map(d => {
          if(d > 0) {
            prevData = d
          }
          // return d === 0 ? prevData : d
          return d
        });
        data.data = tempData.reverse();
        series.push(data);
      }

      let xCat = [];
      xCat = Object.assign(xCat, this.sku.competition.trend.labels);


      // this.$refs.competeTrend.addXaxisAnnotation({
      //   x: 40,
      //   label: {
      //     text: 'Lorem Ipsum'
      //   },
      // })

        for(let sr of series) {
          console.log('sr > name', sr.name);
          console.log('sr > data', sr.data);
          const srData = Object.assign([], sr.data);
          const cat = Object.assign([], xCat);

          for(let dataIdx in srData.reverse()) {
            
            if(!srData[dataIdx] && dataIdx === '1') {
              if(oosMap.has(cat[dataIdx])) {
                let channel = oosMap.get(cat[dataIdx])
                oosMap.set(cat[dataIdx], channel +', '+sr.name);
              } else {
                oosMap.set(cat[dataIdx], sr.name);
              }
              break;
            }
          }
          console.log('oos > map', oosMap);
      }

      let annotations = {            
            xaxis: [
            ]
      }

      for(let key of oosMap.keys()) {
        let txt = 'OOS - '+oosMap.get(key)
        annotations.xaxis.push({
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                x: key ? appCommons.formatDate(key, 'DD/MM/YYYY', 'DD MMM') : key,
                strokeDashArray: 0,
                borderColor: "#FF4560",
                label: {
                  borderColor: "#FF4560",
                  offsetX: -2.5*(txt.length),
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  },
                  orientation: "horizontal",
                  text: txt
                }
              });
      }

      this.competeGraph.chartOptions.annotations = annotations;
      this.competeGraph.chartOptions.xaxis.categories = xCat.reverse();
      // this.competeGraph.series.clear();
      this.competeGraph.series = series;

      return this.competeGraph;
    },
    getOrderStatusColor(status) {
      if (status == "on hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    getCompeteIndexColor(tr) {
      if (tr.pos === "down") return tr.price > 0 ? "success" : "warning";
      return "danger";
    },
    getStockStatusColor(tr) {
      if (tr.price > 0 || tr.client_price > 0)
        return tr.just_in_stock ? "warning" : "success";
      return "danger";
    },
    getStockStatus(tr) {
      if (tr.price > 0 || tr.client_price > 0)
        return tr.just_in_stock ? "Back in Stock" : "";
      return "Out of Stock";
    },
    getCompeter(tr) {
      return Number(tr.price) === Number(this.sku.competition.bestPrice)
        ? "text-danger"
        : "";
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map(item => {
        const fields = item.fields;
        let obj = {};
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue;
        }
        return obj;
      });
      return formattedData;
    },
    viewDetails() {
      this.$vs.notify({
        time: 2500,
        title: "Info",
        text: "Feature: TODO",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    hideSkuContainer() {
      this.$router.push('/competer/stock').catch(e=> {});
    },

    isSelected(item) {
      return this.selectedUnitsToCompare.indexOf(item.code) > -1;
    },
    compare(ref) {
      if(ref) {
        let index = this.selectedUnitsToCompare.indexOf(ref);

        if (index > -1) {
          this.selectedUnitsToCompare.splice(index, 1);
        } else {
          this.selectedUnitsToCompare.push(ref)
        }
      }

      this.channels = new Map();
      let selectedUnits = []
      if(this.sku && this.sku.sku_id) {
        for(let source of this.sku.competition.source) {
          this.channels.set(source.name, source.name)
        }

        if(this.sku.similar) {
          for(let unit of this.sku.similar) {
            if(this.selectedUnitsToCompare.includes(unit.code)) {
              selectedUnits.push(unit)
            }
          }
        }

        for(let selectedUnit of selectedUnits) {
          for(let source of selectedUnit.competition.source) {
            this.channels.set(source.name, source.name)
          }
        }
      }
      this.buildCompareGrid();
    },
    buildCompareGrid() {
      this.compareUnits = []
      let selectedUnits = []
      if(this.sku && this.sku.sku_id) {
        if(this.sku.similar) {
          for(let unit of this.sku.similar) {
            if(this.selectedUnitsToCompare.includes(unit.code)) {
              selectedUnits.push(unit)
            }
          }
        }

        let channelGrid = new Map()
        for(let channel of this.channels.keys()) {
          for(let source of this.sku.competition.source) {
            if(source.name === channel) {
              channelGrid.set(channel, {...source})
            }
          }
          if(!channelGrid.has(channel)) {
            channelGrid.set(channel, {"price": "-na-"})
          }
        }

        let baseUnit = {
          "sku_id": this.sku.sku_id,
          "code": this.sku.code,
          "name": this.sku.name,
          "category": this.sku.category,
          "brand": this.sku.brand,
          "status": this.sku.status,
          "image": this.sku.image,
          "client_price": this.sku.client_price,
          "price_index": this.sku.price_index,
          "bestPrice": this.sku.competition.bestPrice,
          "channels": channelGrid
        }
        
        this.compareUnits.push(baseUnit);
      }
      
      for(let selectedUnit of selectedUnits) {
        let channelGrid = new Map()
        for(let channel of this.channels.keys()) {
          for(let source of selectedUnit.competition.source) {
            if(source.name === channel) {
              channelGrid.set(channel, {...source})
            }
          }
          if(!channelGrid.has(channel)) {
            channelGrid.set(channel, {"price": "-na-"})
          }
        }
        
        let compareUnit = {
          "sku_id": selectedUnit.sku_id,
          "code": selectedUnit.code,
          "name": selectedUnit.name,
          "category": selectedUnit.category,
          "brand": selectedUnit.brand,
          "status": selectedUnit.status,
          "image": selectedUnit.image,
          "client_price": selectedUnit.client_price,
          "price_index": selectedUnit.price_index,
          "bestPrice": selectedUnit.competition.bestPrice,
          "channels": channelGrid
        }
        
        this.compareUnits.push(compareUnit);
      }
    },

    showTrend(item) {
      this.callInProgress = true;
      this.$router.push("/competer/sku/" + item.code);
      this.getSkuInfo(item.code);
    },
    seriesSpark(data) {
      let tempSource = []
      let series = [
        {
          name: [],
          data: []
        }
      ];
      
      tempSource = Object.assign(tempSource, data.source);
      
      tempSource.sort(function(a, b) {
        return a.price - b.price;
      });
      // series[0].name.push("Our Price");
      // series[0].data.push(data.price);

      for (let i = 0; i < (tempSource ? tempSource.length : 0); i++) {
        if (tempSource[i].price && tempSource[i].price !== "0") {
          series[0].name.push(tempSource[i].name);
          series[0].data.push(tempSource[i].price);
        }
      }

      this.nextBestPrice = tempSource[(tempSource.length - 2 > 0 ? tempSource.length : 0)];

      return series;
    }
  },
  components: {
    VueApexCharts,
    VuePerfectScrollbar,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    swiper,
    swiperSlide,
    ManageSku,
    StarRating
  },
  created() {},
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.getSkuInfo();
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
@import "@/assets/scss/vuexy/pages/profile.scss";

#sku-detail {
  .competeTrend {
    width: 100%;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

  .swiper-wrapper {
    padding-bottom: 2rem;

    > .swiper-slide {
      background-color: #f7f7f7;
      box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

      .theme-dark & {
        background-color: $theme-light-dark-bg;
      }
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(.5);
    filter: hue-rotate(40deg);
  }

  .swiper-button-next {
    right: 0
  }

  .swiper-button-prev {
    left: 0;
  }
  }
}

// .swiper-slide {
//   text-align: center;
//   font-size: 18px;
//   background: #444 !important;
// }

// .swiper-slide img {
//   width: auto;
//   height: auto;
//   max-width: 100%;
//   /*max-height: 100%;*/
//   -ms-transform: translate(-50%, -50%);
//   -webkit-transform: translate(-50%, -50%);
//   -moz-transform: translate(-50%, -50%);
//   transform: translate(-50%, -50%);
//   position: absolute;
//   left: 50%;
//   top: 50%;
// }
</style>